import { useAppDispatch } from "@sso/hooks/useRedux";
import { closeDialog } from "@sso/store/slices/dialog";
import { Button } from "@sso/ui/Button";
import { RowContainer } from "@sso/ui/FlexBox";

interface DialogStepperButtonsProps {
  onNext: () => void;
  onBack?: () => void;
  onClickCancel?: () => void;
  isFirstStep?: boolean;
  isLastStep?: boolean;
}

export const DialogStepperButtons = ({
  onNext,
  onBack,
  onClickCancel,
  isFirstStep,
  isLastStep,
}: DialogStepperButtonsProps) => {
  const dispatch = useAppDispatch();

  const handleCancel = () => {
    dispatch(closeDialog());
    onClickCancel?.();
  };

  return (
    <RowContainer position="relative" width="100%" padding="0.5rem 0" justify="flex-end">
      <Button variant="text" padding="0.5rem" type="button" onClick={handleCancel}>
        Cancel
      </Button>

      <Button variant="text" padding="0.5rem" type="button" onClick={onBack} disabled={!onBack || isFirstStep}>
        Back
      </Button>

      {!isLastStep ? (
        <Button variant="text" padding="0.5rem" margin="0.2rem 1rem 0.2rem 0.2rem" type="button" onClick={onNext}>
          Next
        </Button>
      ) : (
        <Button variant="text" padding="0.5rem" margin="0.2rem 1rem 0.2rem 0.2rem" type="submit">
          Submit
        </Button>
      )}
    </RowContainer>
  );
};
